/*eslint-disable react/no-unescaped-entities */
import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { formatMemberName } from '../../../../utils/common';
import {
  NavigationStepsActiveSVG,
  NavigationStepsSuccessSVG,
  NavigationStepsBeforeActiveSVG,
} from '../EnrollmentIconsSvg';
import '../../enrollment.scss';

const NavigationSteps = ({
  navigationStepName,
  currectStep,
  keyIndex,
  enrollmentFormData,
  currentStepKey,
}) => {
  const { Default_Time_Format } = useSelector(
    ({ app }) => app.appConfigs.Time_Setting,
  );

  const getupdatedMemberName = () => {
    const memberInformation =
      enrollmentFormData?.updatedMemberInformation || {};
    //console.log('memberInformation >>>>>>>>> ', memberInformation);
    return formatMemberName(memberInformation?.MemberInformation || {});
  };

  const formatDependentName = (userInfo) => {
    console.log('formatDependentName >>>>>>>> ', userInfo.DepLastName);
    return `${userInfo.Suffix ? userInfo.Suffix : ''} ${
      userInfo.LastName ? userInfo.LastName : ''
    }${userInfo.FirstName ? ', ' + userInfo.FirstName : ''} ${
      userInfo.MiddleName ? userInfo.MiddleName : ''
    } ${userInfo.Title ? userInfo.Title : ''}`;
  };
  const displaySelectedItems = () => {
    switch (navigationStepName) {
      case 'Effective Date':
        if (enrollmentFormData?.adoptionOrBirthDate) {
          return moment(enrollmentFormData?.adoptionOrBirthDate).format(
            Default_Time_Format,
          );
        } else {
          return null;
        }
      case 'Member Profile':
        if (
          enrollmentFormData?.isMemberAddressUpdated &&
          currentStepKey !== 'Member Profile'
        ) {
          return (
            <>
              <span>{getupdatedMemberName()}</span>
              <span>&nbsp;</span>
              <span className="updated-text">Updated</span>
            </>
          );
        } else {
          return null;
        }
      case 'Dependent Information':
        if (currentStepKey !== 'Dependent Information') {
          const removedNewlyAddedDependent =
            enrollmentFormData.removedExistingDependent.filter((object) => {
              return !object?.DependentNewlyAdded;
            });
          if (
            removedNewlyAddedDependent.length > 0 ||
            enrollmentFormData.allNewlyAddedDependent.length > 0 ||
            enrollmentFormData.updatedDependentDetails.length > 0
          ) {
            const removedDep = removedNewlyAddedDependent.map((item, index) => (
              <div key={index}>
                {index === 0 ? (
                  <>
                    <span>
                      {formatDependentName(item.DependentsInformation)}
                    </span>
                    <span>&nbsp;</span>
                    <span className="removed-text">Removed</span>
                  </>
                ) : (
                  <span>{formatDependentName(item.DependentsInformation)}</span>
                )}
              </div>
            ));
            const addedNewly = enrollmentFormData.allNewlyAddedDependent.map(
              (item, index) => (
                <div key={index}>
                  {index === 0 ? (
                    <>
                      <span>
                        {formatDependentName(item.DependentsInformation)}
                      </span>
                      <span>&nbsp;</span>
                      <span className="updated-text">Newly Added</span>
                    </>
                  ) : (
                    <span>
                      {formatDependentName(item.DependentsInformation)}
                    </span>
                  )}
                </div>
              ),
            );
            const UpdatedDep = enrollmentFormData.updatedDependentDetails.map(
              (item, index) => (
                <div key={index}>
                  {index === 0 ? (
                    <>
                      <span>
                        {formatDependentName(item.DependentsInformation)}
                      </span>
                      <span>&nbsp;</span>
                      <span className="updated-text">Updated</span>
                    </>
                  ) : (
                    <span>
                      {formatDependentName(item.DependentsInformation)}
                    </span>
                  )}
                </div>
              ),
            );
            return (
              <>
                {addedNewly}
                {UpdatedDep}
                {removedDep}
              </>
            );
          } else {
            return null;
          }
        } else {
          return null;
        }
      case 'Product Selection':
        if (currentStepKey !== 'Product Selection') {
          if (
            enrollmentFormData.products.selectedMedicalProduct ||
            enrollmentFormData.products.selectedDentalProduct ||
            enrollmentFormData.products.selectedVisionProduct
          ) {
            let medicalProduct = null;
            let dentalProduct = null;
            let visionProduct = null;
            if (enrollmentFormData.products.selectedMedicalProduct) {
              medicalProduct = (
                <>
                  <div className="product-name-text">Medical</div>
                  <div>
                    {
                      enrollmentFormData.products.selectedMedicalProduct
                        .planTitle
                    }
                  </div>
                </>
              );
            }
            if (enrollmentFormData.products.selectedDentalProduct) {
              dentalProduct = (
                <>
                  <div className="product-name-text">Dental</div>
                  <div>
                    {
                      enrollmentFormData.products.selectedDentalProduct
                        .planTitle
                    }
                  </div>
                </>
              );
            }
            if (enrollmentFormData.products.selectedVisionProduct) {
              visionProduct = (
                <>
                  <div className="product-name-text">Vision</div>
                  <div>
                    {
                      enrollmentFormData.products.selectedVisionProduct
                        .planTitle
                    }
                  </div>
                </>
              );
            }
            return (
              <>
                {medicalProduct}
                {dentalProduct}
                {visionProduct}
              </>
            );
          } else {
            return null;
          }
        } else {
          return null;
        }
      case 'Upload Documents':
        if (
          currentStepKey !== 'Upload Documents' &&
          enrollmentFormData.uploadedDocuments.length > 0
        ) {
          const selectedDocuments = enrollmentFormData.uploadedDocuments.map(
            (item, index) => (
              <div key={index}>
                <div>{item?.file?.name}</div>
              </div>
            ),
          );
          return <>{selectedDocuments}</>;
        } else {
          return null;
        }
      default:
        return null;
    }
  };
  return (
    <div
      className={`navigation-steps ${
        currectStep === keyIndex ? 'navigation-Active-steps' : null
      }`}
    >
      <div>
        <span className="nav-steps-svg">
          {currectStep === keyIndex ? (
            <NavigationStepsActiveSVG
              activeBgClassName="active-bg"
              activeOutlineClassName="active-outline"
            />
          ) : currectStep < keyIndex ? (
            <NavigationStepsBeforeActiveSVG
              inactiveClassNameBg="inactiveClassNameBg"
              inactiveClassNameOutline="inactiveClassNameOutline"
            />
          ) : (
            <NavigationStepsSuccessSVG
              successBgClassName="successBgClassName"
              successOutlineClassName="successOutlineClassName"
            />
          )}
        </span>
        <span
          className={
            currectStep === keyIndex
              ? 'nav-step-name nav-step-name-active'
              : 'nav-step-name'
          }
        >
          {navigationStepName}
        </span>
      </div>
      <div className="selected-values">{displaySelectedItems()}</div>
    </div>
  );
};

export default NavigationSteps;
